import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/Header.css';
import '../com.zedock.common.style/common.css';

var cartCount =   document.cookie.match(/(?:^|; )cartCount=([^;]*)/)?.[1] ?? 0

export function updateCartCount(e) {
    cartCount = e
}
function Header() {

    useEffect(() => {
        cartCount =   document.cookie.match(/(?:^|; )cartCount=([^;]*)/)?.[1] ?? 0
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const user = localStorage.getItem("userName");
    const handleClick = async () => {
        try {
            if (user) {
                const response = await

                    fetch(`${urls.BASE_URL}` + "/logout", {

                        method: "POST", // Spring Security expects POST by default
                        headers: {
                            "X-XSRF-TOKEN": getCsrfToken()
                        },
                        credentials: "include" // ensures JSESSIONID cookie is sent
                    });

                localStorage.clear();

                navigate("/Product"); // homepage
                window.location.reload();

            } else {
                localStorage.clear();

                navigate("/Login", { state: { from: location } });
            }
        } catch (error) {

        }
        finally {

        }
    };

    return (
        <div className="container ">
            <div className="row   zd-sticky ">
                <div className="col-12 fs-6  px-0">
                    <nav className="navbar navbar-expand-lg zd-navbar rounded-3 " data-bs-theme="dark">
                        <div className="container-fluid">

                            <a className="zd-brand-mark" onClick={() => navigate("/Product", { state: { category: "" } })}>
                                <img src={urls.CDN_URL + "Zedock.webp"} alt="Zedock" height={40} width={40} />
                                <span className="navbar-brand zd-brand-name mb-0"><span>Zedock</span> Shoppers</span>
                            </a>

                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-lg-center">
                                    <li className="nav-item">
                                        <a className="nav-link zd-nav-link active cursor-pointer" href="#"
                                            onClick={() => {
                                                navigate("/Product", { state: { category: "" } })
                                                //  bsCollapse.hide();
                                            }}>All Products</a>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <a className="nav-link zd-nav-link dropdown-toggle cursor-pointer" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Categories
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Wooden Wall Hanging" } })}>Wooden Wall Hanging</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Wooden Serving Tray" } })}>Wooden Serving Tray</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Homes Decoration" } })}>Homes Decoration</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Charming Elephant Set" } })}>Charming Elephant Set</a></li>

                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Wooden Dhoop Stand" } })}>Wooden Dhoop Stand</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Floating Diya Stand" } })}>Floating Diya Stand</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Door Decoration" } })}>Door Decoration</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Sculpture" } })}>Sculpture</a></li>

                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "USB LED Night Light" } })}>USB LED Night Light</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Product", { state: { category: "Metal Flower Vase" } })}>Metal Flower Vase</a></li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <a className="nav-link zd-nav-link cursor-pointer" href="#" onClick={() => navigate("/AboutUs")}>About Us</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link zd-nav-link cursor-pointer" href="#" onClick={() => navigate("/ContactUs")}>Contact Us</a>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <a className="nav-link zd-nav-link dropdown-toggle cursor-pointer" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Help &amp; Support
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Policies/PrivacyPolicy")}>Privacy Policy</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Policies/TermsConditions")}>Terms &amp; Conditions</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Policies/ReturnRefundCancellationPolicy")}>Return, Refund &amp; Cancellation Policy</a></li>
                                            <li><a className="dropdown-item" href="#" onClick={() => navigate("/Policies/ShippingPolicy")}>Shipping Policy</a></li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <a className="nav-link zd-nav-link zd-track cursor-pointer" href="#" onClick={() => navigate("/Order")}>Track Order</a>
                                    </li>
                                </ul>

                                <div className="zd-nav-actions">
                                    <a className="zd-cart-btn cursor-pointer" href="#" onClick={() => navigate("/Cart")} aria-label="Cart">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>
                                            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                                        </svg>
                                        {cartCount != 0 && (
                                            <span className="zd-cart-badge">{cartCount}</span>
                                        )
                                        }
                                    </a>

                                    <button className="zd-btn-outline" type="submit" onClick={handleClick}>{user ? "Logout" : "Login"}</button>

                                    {!user && (
                                        <button className="zd-btn-solid" type="submit" onClick={() => navigate("/SignUp")}>Sign Up</button>
                                    )}
                                </div>
                            </div>

                        </div>
                    </nav>
                </div>
            </div>
        </div>
    );
}

export default Header;
